export default "__VITE_ASSET__DgjnRK$g__"